<div class="video-player-container">
    <app-youtube-player [videoId]="videoId" [clickToOpenInDialog]="false"></app-youtube-player>
</div>